export default {
  appTitle: 'LoanKnow - Local',
  apiUrl: 'https://localhost:8015/api',
  appEnv: 'development',
  p2enabled: false,
  useMockServices: false,
};
